module.exports = __webpack_public_path__ + "img/header-diamondJewelryPlatinum@2x.c9698da.webp";